"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _constants = require("@ahmdigital/constants");
var _getproducttypefromproductid = /*#__PURE__*/ _interop_require_default(require("../shared/utils/get-product-type-from-product-id"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = {
    id: '6wfho',
    rewards: [
        {
            id: '6-weeks-free-hospital-only',
            isEligible: function() {
                var productId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).productId;
                if (!productId) return false;
                var productType = (0, _getproducttypefromproductid.default)(productId);
                return productType === _constants.PRODUCT_TYPE.HOSPITAL;
            },
            isHospitalOnly: function() {
                return true;
            }
        }
    ]
};
